module.exports = __webpack_public_path__ + "img/20201107_203940.a0ea789b.jpg";